/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddressTriggerWorkflow } from '../../models/address-trigger-workflow';
import { AddressTriggerWorkflowUpdateRequest } from '../../models/address-trigger-workflow-update-request';

export interface UpdateAddressTriggerWorkflow$Params {
  id: string;
      body: AddressTriggerWorkflowUpdateRequest
}

export function updateAddressTriggerWorkflow(http: HttpClient, rootUrl: string, params: UpdateAddressTriggerWorkflow$Params, context?: HttpContext): Observable<StrictHttpResponse<AddressTriggerWorkflow>> {
  const rb = new RequestBuilder(rootUrl, updateAddressTriggerWorkflow.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddressTriggerWorkflow>;
    })
  );
}

updateAddressTriggerWorkflow.PATH = '/api/v1/workflows/address-trigger-workflows/{id}';
